module.exports = __webpack_public_path__ + "img/icon-confirm.e57b21ba.svg";